import {call} from "../../../../shared/SagaService";
import {get} from "../../../../shared/ApiService";
import {Type} from "../../helper";

export function* readTransaction(url, transactionType, context) {
    const response = yield call(get, url, null, context);
    const data = yield response.data;

    if (transactionType === Type.stock_value)
        return data;
    return data.transaction;
}
